<header class="page-header">
  <h1>Calendario manutenzioni</h1>
  <p>{{ monthLabel }} — programmate e scadenze</p>
</header>

<div class="weekdays">
  <span>Lun</span><span>Mar</span><span>Mer</span><span>Gio</span><span>Ven</span><span>Sab</span><span>Dom</span>
</div>
<div class="month-grid">
  @for (cell of days; track cell.date.toISOString()) {
    <div class="day" [class.muted]="!inMonth(cell.date)">
      <div class="num">{{ cell.date.getDate() }}</div>
      @for (e of cell.events; track e.id) {
        <a class="evt" [attr.data-status]="e.status" [routerLink]="['/machines', e.machine_id]" [title]="e.title">
          {{ e.title }}
        </a>
      }
    </div>
  }
</div>
